import * as React from "react";

import { LOADING } from "common/components/types";
import { GlideFunctionalRenderer } from "common/components/uis";
import { styled } from "../styled-components";
import { asString } from "common/components/component-helpers";
import AppIcon from "common/app-icon";
import { ActionSource } from "common/components/computation-types";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";

const CircleButtonStyle = styled.div`
    width: ${p => p.theme.pageMarginMedium * 2 + 24}px;
    height: 48px;

    padding: ${p => p.theme.componentInnerVerticalPadding}px ${p => p.theme.pageMarginMedium}px;

    .cbs-inner {
        display: flex;
        justify-content: center;
        align-items: center;

        background-color: ${p => p.theme.destroyColor};
        border-radius: 1000px;
        color: white;

        width: 24px;
        height: 24px;
    }
`;

export const CircleButtonAccessoryMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[iconPV, onClickPV]] = useForceValueProducers(getValueProducers, force, ctx);
    const { onClick } = useOnClickFromAction(onClickPV, ActionSource.None, ctx, env);
    if (iconPV === LOADING) {
        return env.renderProgress();
    }

    const icon = asString(iconPV);
    return (
        <CircleButtonStyle onClick={onClick !== undefined ? () => onClick(undefined) : undefined}>
            <div className="cbs-inner">
                <AppIcon icon={icon} size={12} />
            </div>
        </CircleButtonStyle>
    );
};
